// @ts-nocheck
class CharmBundleAssetController {
  constructor(root) {
    this.root = root;
    this.base = null;
    this.charms = new Map();
    this.maxCharms = Number(root.dataset.maxCharms) || 8;
    this.modal = root.querySelector('[data-charm-bundle-product-modal]');
    this.giftBoxDrawer = root.querySelector('[data-charm-bundle-gift-box-drawer]');
    this.modalSourceButton = null;
    this.modalImages = [];
    this.modalSlideIndex = 0;
    this.previousFocus = null;
    this.giftBoxPreviousFocus = null;
    this.modalCloseTimer = null;
    this.giftBoxCloseTimer = null;
    this.giftBoxOpenTimer = null;
    this.baseWarningTimer = null;
    this.modalGalleryInstance = null;
    this.modalGalleryPointer = null;
    this.cardGalleryPointer = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleModalGalleryPointerDown = this.handleModalGalleryPointerDown.bind(this);
    this.handleModalGalleryPointerMove = this.handleModalGalleryPointerMove.bind(this);
    this.handleModalGalleryPointerUp = this.handleModalGalleryPointerUp.bind(this);
    this.handleCardGalleryPointerDown = this.handleCardGalleryPointerDown.bind(this);
    this.handleCardGalleryPointerMove = this.handleCardGalleryPointerMove.bind(this);
    this.handleCardGalleryPointerUp = this.handleCardGalleryPointerUp.bind(this);

    root.addEventListener('click', this.handleClick, { capture: true });
    root.addEventListener('keydown', this.handleKeydown);
    root.addEventListener('pointerdown', this.handleCardGalleryPointerDown);
    root.addEventListener('pointermove', this.handleCardGalleryPointerMove);
    root.addEventListener('pointerup', this.handleCardGalleryPointerUp);
    root.addEventListener('pointercancel', this.handleCardGalleryPointerUp);
    document.addEventListener('keydown', this.handleDocumentKeydown);

    if (this.modal) {
      this.modal.addEventListener('pointerdown', this.handleModalGalleryPointerDown);
      this.modal.addEventListener('pointermove', this.handleModalGalleryPointerMove);
      this.modal.addEventListener('pointerup', this.handleModalGalleryPointerUp);
      this.modal.addEventListener('pointercancel', this.handleModalGalleryPointerUp);
    }

    this.render();
  }

  handleClick(event) {
    const control = event.target instanceof Element ? event.target.closest('[data-charm-bundle-action]') : null;
    if (!(control instanceof HTMLElement) || !this.root.contains(control)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const action = control.dataset.charmBundleAction;

    if (action === 'open-product-modal') {
      const card = control.closest('product-card-secondary');
      if (card instanceof HTMLElement && card.dataset.charmBundleSuppressClick === 'true') {
        card.dataset.charmBundleSuppressClick = 'false';
        return;
      }

      this.openProductModal(control);
      return;
    }

    if (action === 'close-product-modal') {
      this.closeProductModal();
      return;
    }

    if (action === 'modal-select-item') {
      this.selectModalItem();
      return;
    }

    if (action === 'modal-gallery-prev') {
      this.setModalSlide(this.modalSlideIndex - 1);
      return;
    }

    if (action === 'modal-gallery-next') {
      this.setModalSlide(this.modalSlideIndex + 1);
      return;
    }

    if (action === 'modal-gallery-dot') {
      this.setModalSlide(Number(control.dataset.modalSlideIndex) || 0);
      return;
    }

    if (action === 'show-gift-box') {
      this.showGiftBox();
      return;
    }

    if (action === 'close-gift-box') {
      this.closeGiftBox();
      return;
    }

    if (action === 'confirm-gift-box') {
      this.confirmGiftBox(control);
      return;
    }

    if (action === 'remove-gift-box-item') {
      this.removeGiftBoxItem(control);
      return;
    }

    if (!(control instanceof HTMLButtonElement)) return;

    if (action === 'select-base') {
      this.selectBase(control);
      return;
    }

    if (action === 'toggle-charm') {
      this.toggleCharm(control);
      return;
    }

    if (action === 'increase-charm') {
      this.increaseCharm(control);
      return;
    }

    if (action === 'decrease-charm') {
      this.decreaseCharm(control);
      return;
    }

    if (action === 'add-bundle') {
      this.showGiftBox();
    }
  }

  handleKeydown(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const action = event.target.dataset.charmBundleAction;

    if (action === 'show-gift-box') {
      event.preventDefault();
      this.showGiftBox();
      return;
    }

    if (action === 'modal-gallery-dot') {
      event.preventDefault();
      this.setModalSlide(Number(event.target.dataset.modalSlideIndex) || 0);
    }
  }

  handleDocumentKeydown(event) {
    if (event.key !== 'Escape') return;

    if (this.isGiftBoxOpen()) {
      event.preventDefault();
      this.closeGiftBox();
      return;
    }

    if (this.isModalOpen()) {
      event.preventDefault();
      this.closeProductModal();
    }
  }

  handleModalGalleryPointerDown(event) {
    if (this.modalGalleryInstance || this.modalImages.length < 2) return;
    if (event.button !== undefined && event.button !== 0) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button, .dot')) return;

    const gallery = event.target.closest('[data-charm-bundle-modal-gallery]');
    if (!(gallery instanceof HTMLElement)) return;

    const viewport = gallery.querySelector('.charm-bundle-product-modal__viewport');
    const track = gallery.querySelector('[data-charm-bundle-modal-track]');
    if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement)) return;

    this.modalGalleryPointer = {
      id: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      currentX: event.clientX,
      isDragging: false,
      viewportWidth: viewport.clientWidth || gallery.clientWidth || 1,
      track,
      gallery,
    };

    if (typeof gallery.setPointerCapture === 'function') {
      gallery.setPointerCapture(event.pointerId);
    }
  }

  handleModalGalleryPointerMove(event) {
    const pointer = this.modalGalleryPointer;
    if (!pointer || pointer.id !== event.pointerId) return;

    const deltaX = event.clientX - pointer.startX;
    const deltaY = event.clientY - pointer.startY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);

    if (!pointer.isDragging && absX < 8) return;
    if (!pointer.isDragging && absY > absX) return;

    pointer.isDragging = true;
    pointer.currentX = event.clientX;
    event.preventDefault();

    pointer.track.style.transition = 'none';
    pointer.track.style.transform = `translate3d(${this.modalSlideIndex * -pointer.viewportWidth + deltaX}px, 0, 0)`;
  }

  handleModalGalleryPointerUp(event) {
    const pointer = this.modalGalleryPointer;
    if (!pointer || pointer.id !== event.pointerId) return;

    const deltaX = pointer.currentX - pointer.startX;
    const shouldChangeSlide = pointer.isDragging && Math.abs(deltaX) > pointer.viewportWidth * 0.16;
    const nextIndex = shouldChangeSlide
      ? this.modalSlideIndex + (deltaX < 0 ? 1 : -1)
      : this.modalSlideIndex;

    pointer.track.style.transition = '';
    this.modalGalleryPointer = null;
    this.setModalSlide(nextIndex);

    if (typeof pointer.gallery.releasePointerCapture === 'function') {
      pointer.gallery.releasePointerCapture(event.pointerId);
    }
  }

  handleCardGalleryPointerDown(event) {
    if (!this.isMobileViewport()) return;
    if (event.button !== undefined && event.button !== 0) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button, add-to-box-item, .select__product_box_wrapper')) return;

    const card = event.target.closest('product-card-secondary');
    if (!(card instanceof HTMLElement) || !this.root.contains(card)) return;

    const primary = card.querySelector('.charm-bundle-builder__image--primary');
    const secondary = card.querySelector('.charm-bundle-builder__image--secondary');
    const media = event.target.closest('.charm-bundle-builder__media');
    if (!(primary instanceof HTMLImageElement) || !(secondary instanceof HTMLImageElement) || !(media instanceof HTMLElement)) {
      return;
    }

    card.dataset.charmBundleSuppressClick = 'false';
    this.cardGalleryPointer = {
      id: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      currentX: event.clientX,
      isDragging: false,
      card,
      media,
    };

    if (typeof media.setPointerCapture === 'function') {
      media.setPointerCapture(event.pointerId);
    }
  }

  handleCardGalleryPointerMove(event) {
    const pointer = this.cardGalleryPointer;
    if (!pointer || pointer.id !== event.pointerId) return;

    const deltaX = event.clientX - pointer.startX;
    const deltaY = event.clientY - pointer.startY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);

    if (!pointer.isDragging && absX < 10) return;
    if (!pointer.isDragging && absY > absX) {
      if (typeof pointer.media.releasePointerCapture === 'function') {
        pointer.media.releasePointerCapture(event.pointerId);
      }
      this.cardGalleryPointer = null;
      return;
    }

    pointer.isDragging = true;
    pointer.currentX = event.clientX;
    event.preventDefault();
  }

  handleCardGalleryPointerUp(event) {
    const pointer = this.cardGalleryPointer;
    if (!pointer || pointer.id !== event.pointerId) return;

    const deltaX = pointer.currentX - pointer.startX;
    const threshold = Math.max(42, pointer.media.clientWidth * 0.18);
    const shouldChangeSlide = pointer.isDragging && Math.abs(deltaX) > threshold;

    if (shouldChangeSlide) {
      const currentIndex = pointer.card.classList.contains('is-mobile-secondary-active') ? 1 : 0;
      let nextIndex = currentIndex;

      if (deltaX < 0 && currentIndex === 0) {
        nextIndex = 1;
      } else if (deltaX > 0 && currentIndex === 1) {
        nextIndex = 0;
      }

      this.setCardSlide(pointer.card, nextIndex);
      pointer.card.dataset.charmBundleSuppressClick = 'true';
    }

    if (typeof pointer.media.releasePointerCapture === 'function') {
      pointer.media.releasePointerCapture(event.pointerId);
    }

    this.cardGalleryPointer = null;
  }

  setCardSlide(card, index) {
    if (!(card instanceof HTMLElement)) return;

    const nextIndex = index > 0 ? 1 : 0;
    card.classList.toggle('is-mobile-secondary-active', nextIndex === 1);

    card.querySelectorAll('.charm-bundle-builder__mobile-dot').forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === nextIndex);
    });
  }

  isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  selectBase(button) {
    const item = this.getItemFromButton(button);
    if (!item) return false;

    const wasComplete = this.isBundleComplete();
    this.base = item;
    this.clearMessage();
    this.hideBaseWarning();
    this.render();

    if (!this.openGiftBoxWhenCompleted(wasComplete)) {
      this.scrollToCharms();
    }

    return true;
  }

  toggleCharm(button) {
    const item = this.getItemFromButton(button);
    if (!item) return false;

    if (!this.base) {
      this.showBaseWarning();
      return false;
    }

    if (this.charms.has(item.variantId)) {
      this.charms.delete(item.variantId);
      this.clearMessage();
      this.render();
      return true;
    }

    const wasComplete = this.isBundleComplete();

    if (this.selectedCharmQuantity() >= this.maxCharms) {
      this.showMessage(this.boxFullText());
      return false;
    }

    this.charms.set(item.variantId, { ...item, quantity: 1 });
    this.clearMessage();
    this.render();
    this.openGiftBoxWhenCompleted(wasComplete);
    return true;
  }

  increaseCharm(button) {
    const item = this.getItemFromButton(button);
    if (!item) return false;

    if (!this.base) {
      this.showBaseWarning();
      return false;
    }

    const existing = this.charms.get(item.variantId);
    if (!existing) return false;

    const wasComplete = this.isBundleComplete();

    if (this.selectedCharmQuantity() >= this.maxCharms) {
      this.showMessage(this.boxFullText());
      return false;
    }

    this.charms.set(item.variantId, { ...existing, quantity: existing.quantity + 1 });
    this.clearMessage();
    this.render();
    this.openGiftBoxWhenCompleted(wasComplete);
    return true;
  }

  decreaseCharm(button) {
    const item = this.getItemFromButton(button);
    if (!item) return;

    const existing = this.charms.get(item.variantId);
    if (!existing) return;

    if (existing.quantity <= 1) {
      this.charms.delete(item.variantId);
    } else {
      this.charms.set(item.variantId, { ...existing, quantity: existing.quantity - 1 });
    }

    this.clearMessage();
    this.render();
  }

  async addBundle(button, options = {}) {
    if (!this.base) {
      this.showMessage(this.root.dataset.baseRequiredMessage || '');
      return false;
    }

    if (this.charms.size === 0) {
      this.showMessage(this.root.dataset.charmRequiredMessage || '');
      return false;
    }

    if (this.selectedCharmQuantity() < this.maxCharms) {
      this.showMessage(this.root.dataset.charmIncompleteMessage || '');
      return false;
    }

    if (this.shouldAddSingleBundleLine() && !this.getBundleVariantId()) {
      this.showMessage(this.root.dataset.bundleMissingMessage || this.root.dataset.errorMessage || '');
      return false;
    }

    const originalText = button.textContent;
    const originalHTML = button.innerHTML;

    button.disabled = true;
    this.setButtonLoading(button, true, this.root.dataset.loadingMessage || originalText);

    try {
      const bundleId = `bundle-${Date.now()}`;
      const items = await this.buildCartItems(bundleId);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || this.root.dataset.errorMessage);
      }

      // --- Meta AddToCart bridge --------------------------------------------
      // The bulk /cart/add.js add (run through the bundle cart-transform) does
      // NOT emit Shopify's standard `product_added_to_cart` event, so the Meta
      // app pixel never sees the box add. Publish a custom customer event that
      // a custom pixel can subscribe to and forward to Meta as AddToCart.
      try {
        const added = Array.isArray(result.items)
          ? result.items
          : result.id
          ? [result]
          : items;
        const value =
          added.reduce(
            (sum, it) =>
              sum +
              (it.final_line_price != null
                ? it.final_line_price
                : (it.price || 0) * (it.quantity || 1)),
            0
          ) / 100;
        const payload = {
          content_ids: added.map((it) => String(it.id || it.variant_id)),
          contents: added.map((it) => ({
            id: String(it.id || it.variant_id),
            quantity: it.quantity || 1,
          })),
          content_type: 'product',
          num_items: added.reduce((n, it) => n + (it.quantity || 1), 0),
          value: Number.isFinite(value) && value > 0 ? value : undefined,
          currency: window.Shopify?.currency?.active || 'USD',
        };
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('habiba_box_added_to_cart', payload);
        }
      } catch (e) {
        /* analytics must never block the add-to-cart flow */
      }
      // ----------------------------------------------------------------------

      const cart = await this.fetchCart();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.root.id,
            data: {
              source: 'charm-bundle-builder',
              itemCount: cart?.item_count || items.reduce((total, item) => total + item.quantity, 0),
            },
          },
        })
      );

      if (options.resetSelection !== false) {
        this.base = null;
        this.charms.clear();
      }

      this.showMessage(this.root.dataset.addedMessage || '');
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : this.root.dataset.errorMessage;
      this.showMessage(message || '');
      return false;
    } finally {
      button.disabled = false;
      this.setButtonLoading(button, false, originalText, originalHTML);
      this.render();
    }
  }

  setButtonLoading(button, isLoading, label, originalHTML = '') {
    if (!(button instanceof HTMLButtonElement)) return;

    if (isLoading) {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = `
        <span class="charm-bundle-button__loader" aria-hidden="true"></span>
        <span class="charm-bundle-button__loading-text">${this.escapeHTML((label || '').trim())}</span>
      `;
      return;
    }

    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');

    if (originalHTML) {
      button.innerHTML = originalHTML;
    } else {
      button.textContent = label || '';
    }
  }

  getItemFromButton(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return null;

    return {
      productId: button.dataset.productId || '',
      variantId,
      title: button.dataset.productTitle || '',
      variantTitle: button.dataset.variantTitle || '',
      productUrl: button.dataset.productUrl || '',
      imageUrl: button.dataset.imageUrl || '',
    };
  }

  async buildCartItems(bundleId) {
    if (!this.base) return [];

    if (this.shouldAddSingleBundleLine()) {
      const bundleVariantId = Number(this.getBundleVariantId());

      if (Number.isFinite(bundleVariantId) && bundleVariantId > 0) {
        const properties = await this.buildBundleLineProperties(bundleId);

        return [
          {
            id: bundleVariantId,
            quantity: 1,
            properties,
          },
        ];
      }
    }

    const bundleName = this.base.title;
    const baseItem = {
      id: Number(this.base.variantId),
      quantity: 1,
      properties: {
        Bundle: bundleName,
        'Bundle item': this.root.dataset.bundleBaseLabel || 'Base',
        _bundle_id: bundleId,
        _bundle_role: 'base',
      },
    };

    const charmItems = Array.from(this.charms.values()).map((item) => ({
      id: Number(item.variantId),
      quantity: item.quantity,
      properties: {
        Bundle: bundleName,
        'Bundle item': item.title,
        _bundle_id: bundleId,
        _bundle_role: 'charm',
      },
    }));

    return [baseItem, ...charmItems];
  }

  shouldAddSingleBundleLine() {
    return this.root.dataset.addSingleBundleLine !== 'false';
  }

  getBundleVariantId() {
    return (this.root.dataset.bundleVariantId || '').trim().split('/').pop();
  }

  async buildBundleLineProperties(bundleId) {
    const charms = this.expandedCharmItems();
    const properties = {
      _bundle_id: bundleId,
      _bundle_role: 'bundle',
      _bundle_title: this.root.dataset.bundleProductTitle || 'Charm Bundle',
      _bundle_charm_count_label: `${charms.length} ${charms.length === 1 ? 'Charm' : 'Charms'}`,
      _bundle_image: this.base.imageUrl,
      _bundle_base_price: this.moneyFromCents(this.root.dataset.bundleBasePriceCents),
      _bundle_charm_price: this.moneyFromCents(this.root.dataset.bundleCharmPriceCents),
      _bundle_base_variant_id: this.base.variantId,
      _bundle_base_product_id: this.base.productId,
      _bundle_base_title: this.base.title,
      _bundle_base_image: this.base.imageUrl,
      _bundle_charm_variant_ids: charms.map((item) => item.variantId).join(','),
    };

    charms.forEach((item, index) => {
      const number = index + 1;
      properties[`_bundle_charm_${number}_title`] = item.title;
      properties[`_bundle_charm_${number}_variant_id`] = item.variantId;
      properties[`_bundle_charm_${number}_product_id`] = item.productId;
      properties[`_bundle_charm_${number}_image`] = item.imageUrl;
    });

    if (this.shouldUseMwBundlePayload()) {
      Object.assign(properties, await this.buildMwBundleProperties(bundleId, charms));
    }

    return properties;
  }

  shouldUseMwBundlePayload() {
    return this.root.dataset.mwBundlePayload !== 'false';
  }

  async buildMwBundleProperties(bundleId, charms) {
    const mwBuildOffer = typeof window !== 'undefined' ? window.mwBuildOffer : null;
    const mwConfig = mwBuildOffer?.config || mwBuildOffer?.offer || {};
    const offerId =
      this.cleanValue(mwConfig.offer_id) ||
      this.cleanValue(mwConfig.offerId) ||
      this.cleanValue(mwConfig.id) ||
      this.cleanValue(this.root.dataset.mwOfferId) ||
      this.extractMwOfferIdFromDom();
    const baseCategoryId = this.resolveMwCategoryId('base', mwConfig);
    const charmCategoryId = this.resolveMwCategoryId('charm', mwConfig);
    const marketId =
      this.cleanValue(mwBuildOffer?.marketId) ||
      this.cleanValue(mwConfig.market_id) ||
      this.cleanValue(mwConfig.marketId) ||
      this.cleanValue(this.root.dataset.mwMarketId);
    const bundleVariantId = Number(this.getBundleVariantId() || mwBuildOffer?.variantId);
    const shop =
      this.cleanValue(window.Shopify?.shop) ||
      this.cleanValue(this.root.dataset.mwShopDomain);

    if (!offerId || !baseCategoryId || !charmCategoryId || !marketId || !Number.isFinite(bundleVariantId) || !shop) {
      throw new Error(this.root.dataset.mwMissingMessage || this.root.dataset.errorMessage || '');
    }

    const basePrice = this.moneyNumberFromCents(this.root.dataset.bundleBasePriceCents);
    const charmPrice = this.moneyNumberFromCents(this.root.dataset.bundleCharmPriceCents);
    const calculationItems = [
      {
        base_price: basePrice,
        calc_price: basePrice,
        qty: 1,
        variant_id: Number(this.base.variantId),
        category_id: baseCategoryId,
      },
      ...charms.map((item) => ({
        base_price: charmPrice,
        calc_price: charmPrice,
        qty: 1,
        variant_id: Number(item.variantId),
        category_id: charmCategoryId,
      })),
    ];
    const cart = await this.fetchCart().catch(() => null);
    const marketingOfferId = `${offerId}/${this.cleanValue(this.root.dataset.mwPopupId) || this.root.dataset.sectionId || 'custom'}`;
    const payload = {
      cart_id: cart?.token || bundleId,
      marketing_offer_id: marketingOfferId,
      calculation: {
        country: this.cleanValue(mwBuildOffer?.country) || this.cleanValue(this.root.dataset.mwCountry) || 'GB',
        offer_variant_id: `gid://shopify/ProductVariant/${bundleVariantId}`,
        offer_name:
          this.cleanValue(mwConfig.offer_name) ||
          this.cleanValue(mwConfig.offerName) ||
          this.cleanValue(this.root.dataset.bundleProductTitle) ||
          'Charm Bundle',
        offer_id: this.normalizedMwId(offerId),
        hash: '',
        items: calculationItems,
        gifts: [],
        currency:
          this.cleanValue(window.Shopify?.currency?.active) ||
          this.cleanValue(this.root.dataset.mwCurrency) ||
          'GBP',
        rate: this.normalizedRate(window.mwMarketingOffersHelper?.rate || window.Shopify?.currency?.rate),
        market_id: marketId,
      },
    };
    const response = await fetch(`https://bundle-admin.mageworx.com/front/${shop}/build/process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(this.formatMwError(result) || this.root.dataset.mwErrorMessage || this.root.dataset.errorMessage || '');
    }

    const calculation = result?.calculation || result?.data?.calculation;

    if (!calculation) {
      throw new Error(this.root.dataset.mwErrorMessage || this.root.dataset.errorMessage || '');
    }

    return {
      __mw_build: JSON.stringify(calculation),
      _mw_marketing_offers_offer_id: marketingOfferId,
    };
  }

  resolveMwCategoryId(kind, config) {
    const configured =
      kind === 'base'
        ? this.cleanValue(this.root.dataset.mwBaseCategoryId)
        : this.cleanValue(this.root.dataset.mwCharmCategoryId);

    if (configured) return configured;

    const categories = config?.categories || config?.offer_categories || [];
    const category = this.findMwCategory(categories, kind);

    return this.cleanValue(category?.id || category?.category_id || category?.categoryId || category?.uid);
  }

  findMwCategory(categories, kind) {
    const expected = kind === 'base' ? 'base' : 'charm';

    if (Array.isArray(categories)) {
      return categories.find((category) => {
        const label = `${category?.title || category?.name || category?.category_title || ''}`.toLowerCase();
        return label.includes(expected);
      });
    }

    if (categories && typeof categories === 'object') {
      return Object.entries(categories).find(([, category]) => {
        const label = `${category?.title || category?.name || category?.category_title || ''}`.toLowerCase();
        return label.includes(expected);
      })?.[1];
    }

    return null;
  }

  extractMwOfferIdFromDom() {
    const offer = document.querySelector('mw-build-offer');
    const inner = offer?.shadowRoot?.querySelector('[id^="mw-build-offer-"]');

    return this.cleanValue(inner?.id?.replace('mw-build-offer-', ''));
  }

  expandedCharmItems() {
    const items = [];

    for (const item of this.charms.values()) {
      const quantity = Number(item.quantity) || 1;

      for (let index = 0; index < quantity; index += 1) {
        items.push(item);
      }
    }

    return items;
  }

  moneyFromCents(value) {
    const cents = Number(value);

    if (!Number.isFinite(cents) || cents <= 0) return '';

    return (cents / 100).toFixed(2);
  }

  moneyNumberFromCents(value) {
    const money = Number(this.moneyFromCents(value));

    return Number.isFinite(money) ? money : 0;
  }

  normalizedRate(value) {
    const rate = Number(value);

    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  normalizedMwId(value) {
    const number = Number(value);

    return Number.isFinite(number) ? number : value;
  }

  cleanValue(value) {
    if (value === null || value === undefined) return '';

    return String(value).trim();
  }

  formatMwError(result) {
    if (Array.isArray(result?.detail)) {
      return result.detail
        .map((detail) => detail?.msg || detail?.message)
        .filter(Boolean)
        .join(', ');
    }

    return result?.description || result?.message || result?.error || '';
  }

  async fetchCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return null;

    return response.json();
  }

  render() {
    const selectedCharmQuantity = this.selectedCharmQuantity();

    this.root.classList.toggle('has-selection', Boolean(this.base) || this.charms.size > 0);
    this.root.classList.toggle('has-base-selected', Boolean(this.base));
    this.root.classList.toggle('has-charms-selected', selectedCharmQuantity > 0);
    this.root.classList.toggle('is-complete', this.isBundleComplete());
    this.renderProgressBar(selectedCharmQuantity);
    this.renderBaseCards();
    this.renderCharmCards();
    this.renderSummary();
    this.renderAddButton();
    this.renderGiftBoxDrawer();
    this.renderModalState();
  }

  renderBaseCards() {
    const cards = this.root.querySelectorAll('[products-1-element] [product-grid-element]');

    for (const card of cards) {
      const variantId = card.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
      const isSelected = Boolean(variantId && this.base?.variantId === variantId);
      const selectWrapper = card.querySelector('add-to-box-item');

      card.classList.toggle('is-selected', isSelected);
      selectWrapper?.classList.toggle('selected', isSelected);
    }
  }

  renderCharmCards() {
    const isBoxFull = this.selectedCharmQuantity() >= this.maxCharms;
    const cards = this.root.querySelectorAll('[products-2-element] [product-grid-element]');

    for (const card of cards) {
      const variantId = card.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
      const selectedItem = variantId ? this.charms.get(variantId) : null;
      const quantity = card.querySelector('[total-quantity]');
      const plusButton = card.querySelector('[data-charm-bundle-action="increase-charm"]');
      const selectWrapper = card.querySelector('add-to-box-item');

      card.classList.toggle('is-selected', Boolean(selectedItem));
      card.classList.toggle('is-box-full', isBoxFull);
      selectWrapper?.classList.toggle('selected', Boolean(selectedItem));

      if (quantity) {
        quantity.textContent = selectedItem?.quantity?.toString() || '1';
      }

      if (plusButton instanceof HTMLButtonElement) {
        plusButton.disabled = isBoxFull;
      }
    }
  }

  renderSummary() {
    const summary = this.root.querySelector('[data-charm-bundle-summary]');
    if (!summary) return;

    const charmQuantity = this.selectedCharmQuantity();

    if (!this.base && charmQuantity === 0) {
      summary.textContent = this.root.dataset.summaryEmpty || '';
      return;
    }

    const baseText = this.base ? this.base.title : this.root.dataset.summaryNoBase || '';
    const charmText =
      charmQuantity === 1
        ? this.root.dataset.summaryOneCharm || ''
        : (this.root.dataset.summaryManyCharms || '').replace('__count__', charmQuantity.toString());

    summary.textContent = `${baseText} · ${charmText}`;
  }

  renderProgressBar(selectedCharmQuantity) {
    const count = this.root.querySelector('[data-charm-bundle-progress-count]');
    const max = this.root.querySelector('[data-charm-bundle-progress-max]');

    if (count) {
      count.textContent = selectedCharmQuantity.toString();
    }

    if (max) {
      max.textContent = this.maxCharms.toString();
    }
  }

  showGiftBox() {
    if (!this.base) {
      this.showMessage(this.root.dataset.baseRequiredMessage || '');
      return;
    }

    if (this.selectedCharmQuantity() < this.maxCharms) {
      this.showMessage(this.root.dataset.charmIncompleteMessage || '');
      this.scrollToCharms();
      return;
    }

    this.openGiftBox();
  }

  openGiftBox() {
    if (!this.giftBoxDrawer) return;

    if (this.giftBoxOpenTimer) {
      window.clearTimeout(this.giftBoxOpenTimer);
      this.giftBoxOpenTimer = null;
    }

    this.renderGiftBoxDrawer();

    if (this.giftBoxCloseTimer) {
      window.clearTimeout(this.giftBoxCloseTimer);
      this.giftBoxCloseTimer = null;
    }

    this.giftBoxPreviousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.giftBoxDrawer.hidden = false;
    this.giftBoxDrawer.setAttribute('aria-hidden', 'false');
    this.giftBoxDrawer.classList.remove('gift-box-drawer--is-closing');
    document.documentElement.classList.add('charm-bundle-gift-box-open');

    window.requestAnimationFrame(() => {
      this.giftBoxDrawer?.classList.add('gift-box-drawer--is-open');
      const panel = this.giftBoxDrawer?.querySelector('.gift-box-drawer__panel');
      if (panel instanceof HTMLElement) panel.focus({ preventScroll: true });
    });
  }

  closeGiftBox() {
    if (!this.giftBoxDrawer) return;

    if (this.giftBoxOpenTimer) {
      window.clearTimeout(this.giftBoxOpenTimer);
      this.giftBoxOpenTimer = null;
    }

    this.giftBoxDrawer.classList.remove('gift-box-drawer--is-open');
    this.giftBoxDrawer.classList.add('gift-box-drawer--is-closing');
    this.giftBoxDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('charm-bundle-gift-box-open');

    if (this.giftBoxCloseTimer) {
      window.clearTimeout(this.giftBoxCloseTimer);
    }

    this.giftBoxCloseTimer = window.setTimeout(() => {
      if (!this.giftBoxDrawer || this.giftBoxDrawer.classList.contains('gift-box-drawer--is-open')) return;

      this.giftBoxDrawer.hidden = true;
      this.giftBoxDrawer.classList.remove('gift-box-drawer--is-closing');
      this.giftBoxCloseTimer = null;

      if (this.giftBoxPreviousFocus) {
        this.giftBoxPreviousFocus.focus({ preventScroll: true });
        this.giftBoxPreviousFocus = null;
      }
    }, 380);
  }

  isGiftBoxOpen() {
    return Boolean(
      this.giftBoxDrawer &&
        !this.giftBoxDrawer.hidden &&
        this.giftBoxDrawer.classList.contains('gift-box-drawer--is-open')
    );
  }

  openGiftBoxWhenCompleted(wasComplete) {
    if (wasComplete || !this.isBundleComplete()) return false;

    if (this.giftBoxOpenTimer) {
      window.clearTimeout(this.giftBoxOpenTimer);
      this.giftBoxOpenTimer = null;
    }

    if (this.isModalOpen()) {
      this.closeProductModal({ restoreFocus: false });
      this.giftBoxOpenTimer = window.setTimeout(() => {
        this.giftBoxOpenTimer = null;
        this.openGiftBox();
      }, 400);
      return true;
    }

    this.openGiftBox();
    return true;
  }

  scrollToCharms() {
    const charmsHeading = this.root.querySelector('.collection_list_step__wrapper__second');
    if (!(charmsHeading instanceof HTMLElement)) return;

    window.requestAnimationFrame(() => {
      if (this.isMobileViewport()) {
        const headerGroup = document.getElementById('header-group');
        const progressBar = this.root.querySelector('.aex-gift-box-progress-bar');
        const headerHeight = headerGroup instanceof HTMLElement ? headerGroup.getBoundingClientRect().height : 0;
        const progressHeight = progressBar instanceof HTMLElement ? progressBar.getBoundingClientRect().height : 0;
        const offset = Math.max(152, headerHeight + progressHeight + 36);
        const targetTop = charmsHeading.getBoundingClientRect().top + window.pageYOffset - offset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
        return;
      }

      charmsHeading.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }

  renderAddButton() {
    const button = this.root.querySelector('[data-charm-bundle-action="add-bundle"]');
    if (!(button instanceof HTMLButtonElement)) return;

    button.disabled = !this.isBundleComplete();
  }

  selectedCharmQuantity() {
    return Array.from(this.charms.values()).reduce((total, item) => total + item.quantity, 0);
  }

  isBundleComplete() {
    return Boolean(this.base) && this.selectedCharmQuantity() >= this.maxCharms;
  }

  renderGiftBoxDrawer() {
    const container = this.root.querySelector('[data-charm-bundle-gift-box-items]');
    const confirmButton = this.root.querySelector('[data-charm-bundle-confirm]');
    const selectedCharmQuantity = this.selectedCharmQuantity();

    if (confirmButton instanceof HTMLButtonElement) {
      confirmButton.disabled = !this.isBundleComplete();
    }

    if (!(container instanceof HTMLElement)) return;

    const parts = [];

    if (this.base) {
      parts.push(`<div class="charm_base_header">${this.escapeHTML(this.root.dataset.giftBoxBaseLabel || 'Your Base')}</div>`);
      parts.push(this.renderGiftBoxItem(this.base, 'base'));
    }

    if (this.charms.size > 0) {
      const label = this.escapeHTML(this.root.dataset.giftBoxCharmsLabel || 'Your Charms');
      parts.push(`<div class="charm_base_header">${label} (${selectedCharmQuantity}/${this.maxCharms})</div>`);

      for (const item of this.charms.values()) {
        parts.push(this.renderGiftBoxItem(item, 'charm'));
      }
    }

    container.innerHTML =
      parts.length > 0
        ? parts.join('')
        : `<p class="gift-box-drawer__empty">${this.escapeHTML(this.root.dataset.giftBoxEmptyLabel || '')}</p>`;
  }

  renderGiftBoxItem(item, role) {
    const image = item.imageUrl
      ? `<img src="${this.escapeHTML(item.imageUrl)}" alt="${this.escapeHTML(item.title)}" loading="lazy">`
      : '<span class="gift-box-drawer__item-image-placeholder" aria-hidden="true"></span>';
    const quantity = Number(item.quantity) || 1;

    return `
      <div class="aex-gift-box-drawer-list-item no-border" data-gift-box-role="${role}">
        <div class="aex-gift-box-item-title">
          ${image}
          <div class="aex-gift-box-item-text">
            <span>${this.escapeHTML(item.title)}</span>
            <div class="aex-gift-box-item-num-item">x${quantity}</div>
          </div>
        </div>
        <div class="aex-gift-box-item-buttons">
          <button
            type="button"
            class="aex-gift-box-item-remove-item"
            data-charm-bundle-action="remove-gift-box-item"
            data-bundle-role="${role}"
            data-variant-id="${this.escapeHTML(item.variantId)}"
            aria-label="Remove ${this.escapeHTML(item.title)}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none" class="icon icon-close" aria-hidden="true" focusable="false">
              <path d="M25 7L7 25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M25 25L7 7" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  removeGiftBoxItem(control) {
    const variantId = control.dataset.variantId;
    const role = control.dataset.bundleRole;
    if (!variantId) return;

    if (role === 'base' && this.base?.variantId === variantId) {
      this.base = null;
    } else {
      this.charms.delete(variantId);
    }

    this.clearMessage();
    this.render();
  }

  async confirmGiftBox(control) {
    if (!(control instanceof HTMLButtonElement)) return;

    const added = await this.addBundle(control, { resetSelection: false });

    if (added) {
      control.classList.add('is-success');

      window.setTimeout(() => {
        control.classList.remove('is-success');
        this.closeGiftBox();
        this.giftBoxPreviousFocus = null;
        this.openCartDrawer();
      }, 180);

      window.setTimeout(() => {
        this.base = null;
        this.charms.clear();
        this.render();
      }, 520);
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (cartTrigger instanceof HTMLElement) {
      cartTrigger.click();
    }
  }

  boxFullText() {
    const boxFull = this.root.querySelector('.box-full');
    return boxFull?.textContent?.trim() || '';
  }

  showMessage(message) {
    const messageElement = this.root.querySelector('[data-charm-bundle-message]');
    if (!messageElement) return;

    messageElement.textContent = message;
  }

  showBaseWarning() {
    const warning = this.root.querySelector('[data-charm-bundle-base-warning]');
    if (!(warning instanceof HTMLElement)) {
      this.showMessage(this.root.dataset.baseFirstMessage || this.root.dataset.baseRequiredMessage || '');
      return;
    }

    warning.textContent = this.root.dataset.baseFirstMessage || warning.textContent || 'Please select a base item first.';
    warning.hidden = false;
    warning.classList.remove('is-visible');

    if (this.baseWarningTimer) {
      window.clearTimeout(this.baseWarningTimer);
      this.baseWarningTimer = null;
    }

    window.requestAnimationFrame(() => warning.classList.add('is-visible'));
    this.baseWarningTimer = window.setTimeout(() => {
      warning.classList.remove('is-visible');
      this.baseWarningTimer = window.setTimeout(() => {
        warning.hidden = true;
        this.baseWarningTimer = null;
      }, 220);
    }, 2200);
  }

  hideBaseWarning() {
    const warning = this.root.querySelector('[data-charm-bundle-base-warning]');
    if (!(warning instanceof HTMLElement)) return;

    if (this.baseWarningTimer) {
      window.clearTimeout(this.baseWarningTimer);
      this.baseWarningTimer = null;
    }

    warning.classList.remove('is-visible');
    warning.hidden = true;
  }

  clearMessage() {
    this.showMessage('');
  }

  openProductModal(control) {
    if (!this.modal || !(control instanceof HTMLElement)) return;

    const card = control.closest('[product-grid-element]');
    if (!(card instanceof HTMLElement)) return;

    const sourceButton = card.querySelector(
      '[data-charm-bundle-action="select-base"], [data-charm-bundle-action="toggle-charm"]'
    );

    if (!(sourceButton instanceof HTMLButtonElement)) return;

    const productData = this.getProductModalData(card);
    if (!productData) return;

    this.modalSourceButton = sourceButton;
    this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.populateProductModal(productData);

    if (this.modalCloseTimer) {
      window.clearTimeout(this.modalCloseTimer);
      this.modalCloseTimer = null;
    }

    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.remove('is-closing');
    document.documentElement.classList.add('charm-bundle-product-modal-open');

    window.requestAnimationFrame(() => {
      this.modal?.classList.add('modal--is-active');
      this.resizeModalGallery();
      const drawer = this.modal?.querySelector('.charm-bundle-product-modal__drawer');
      if (drawer instanceof HTMLElement) drawer.focus({ preventScroll: true });
    });
  }

  closeProductModal(options = {}) {
    if (!this.modal) return;

    this.modal.classList.remove('modal--is-active');
    this.modal.classList.add('is-closing');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('charm-bundle-product-modal-open');

    if (this.modalCloseTimer) {
      window.clearTimeout(this.modalCloseTimer);
    }

    this.modalCloseTimer = window.setTimeout(() => {
      if (!this.modal || this.modal.classList.contains('modal--is-active')) return;

      this.modal.hidden = true;
      this.modal.classList.remove('is-closing');
      this.modalSourceButton = null;
      this.modalImages = [];
      this.modalSlideIndex = 0;
      this.modalCloseTimer = null;

      if (options.restoreFocus !== false && this.previousFocus) {
        this.previousFocus.focus({ preventScroll: true });
        this.previousFocus = null;
      } else if (options.restoreFocus === false) {
        this.previousFocus = null;
      }
    }, 380);
  }

  isModalOpen() {
    return Boolean(this.modal && !this.modal.hidden && this.modal.classList.contains('modal--is-active'));
  }

  getProductModalData(card) {
    const script = card.querySelector('[data-charm-bundle-product-json]');
    if (!(script instanceof HTMLScriptElement)) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  populateProductModal(productData) {
    if (!this.modal) return;

    const title = this.modal.querySelector('[data-charm-bundle-modal-title]');
    const description = this.modal.querySelector('[data-charm-bundle-modal-description]');
    const descriptionClone = this.modal.querySelector('[data-charm-bundle-modal-description-clone]');

    if (title) title.textContent = productData.title || '';

    if (description) {
      description.innerHTML = productData.description || '';
    }

    if (descriptionClone) {
      descriptionClone.innerHTML = productData.description || '';
    }

    this.renderModalGallery(Array.isArray(productData.images) ? productData.images : []);
    this.renderModalState();
  }

  renderModalGallery(images) {
    if (!this.modal) return;

    const gallery = this.modal.querySelector('[data-charm-bundle-modal-gallery]');
    if (!(gallery instanceof HTMLElement)) return;

    this.destroyModalGallery();
    this.modalImages = images.filter((image) => image && image.src);
    this.modalSlideIndex = 0;
    gallery.classList.remove('charm-bundle-product-modal__gallery--flickity', 'flickity-enabled', 'is-draggable');

    if (this.modalImages.length === 0) {
      gallery.innerHTML = '<div class="charm-bundle-product-modal__gallery-empty"></div>';
      return;
    }

    const slides = this.modalImages
      .map(
        (image, index) => `
          <div class="carousel-cell charm-bundle-product-modal__slide" aria-hidden="${index === 0 ? 'false' : 'true'}">
            <img src="${this.escapeHTML(image.src)}" alt="${this.escapeHTML(image.alt || '')}" loading="lazy">
          </div>
        `
      )
      .join('');

    if (typeof window.Flickity === 'function') {
      gallery.classList.add('charm-bundle-product-modal__gallery--flickity');
      gallery.innerHTML = slides;
      this.modalGalleryInstance = new window.Flickity(gallery, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        imagesLoaded: true,
        pageDots: this.modalImages.length > 1,
        prevNextButtons: this.modalImages.length > 1,
        selectedAttraction: 0.025,
        friction: 0.28,
      });
      return;
    }

    gallery.classList.add('flickity-enabled', 'is-draggable');

    const dots = this.modalImages
      .map(
        (_image, index) => `
          <li
            class="dot${index === 0 ? ' is-selected' : ''}"
            role="button"
            tabindex="0"
            aria-label="Page dot ${index + 1}"
            ${index === 0 ? 'aria-current="step"' : ''}
            data-charm-bundle-action="modal-gallery-dot"
            data-modal-slide-index="${index}"
          ></li>
        `
      )
      .join('');

    gallery.innerHTML = `
      <div class="flickity-viewport charm-bundle-product-modal__viewport">
        <div class="flickity-slider charm-bundle-product-modal__track" data-charm-bundle-modal-track>
          ${slides}
        </div>
      </div>
      ${
        this.modalImages.length > 1
          ? `
            <button class="flickity-button flickity-prev-next-button flickity-previous" type="button" aria-label="Previous" data-charm-bundle-action="modal-gallery-prev">
              <svg class="flickity-button-icon" viewBox="0 0 100 100" aria-hidden="true" focusable="false"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow"></path></svg>
            </button>
            <button class="flickity-button flickity-prev-next-button flickity-next" type="button" aria-label="Next" data-charm-bundle-action="modal-gallery-next">
              <svg class="flickity-button-icon" viewBox="0 0 100 100" aria-hidden="true" focusable="false"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>
            </button>
            <ol class="flickity-page-dots">${dots}</ol>
          `
          : ''
      }
    `;
  }

  setModalSlide(index) {
    if (!this.modal || this.modalImages.length === 0) return;

    const nextIndex = (index + this.modalImages.length) % this.modalImages.length;

    if (this.modalGalleryInstance && typeof this.modalGalleryInstance.select === 'function') {
      this.modalGalleryInstance.select(nextIndex);
      this.modalSlideIndex = nextIndex;
      return;
    }

    const track = this.modal.querySelector('[data-charm-bundle-modal-track]');
    const slides = this.modal.querySelectorAll('.charm-bundle-product-modal__slide');
    const dots = this.modal.querySelectorAll('[data-charm-bundle-action="modal-gallery-dot"]');

    this.modalSlideIndex = nextIndex;

    if (track instanceof HTMLElement) {
      track.style.transform = `translateX(-${nextIndex * 100}%)`;
    }

    slides.forEach((slide, slideIndex) => {
      slide.setAttribute('aria-hidden', slideIndex === nextIndex ? 'false' : 'true');
    });

    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-selected', dotIndex === nextIndex);
      if (dotIndex === nextIndex) {
        dot.setAttribute('aria-current', 'step');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  resizeModalGallery() {
    if (this.modalGalleryInstance && typeof this.modalGalleryInstance.resize === 'function') {
      this.modalGalleryInstance.resize();
    }
  }

  destroyModalGallery() {
    if (this.modalGalleryInstance && typeof this.modalGalleryInstance.destroy === 'function') {
      this.modalGalleryInstance.destroy();
    }

    this.modalGalleryInstance = null;
    this.modalGalleryPointer = null;
  }

  selectModalItem() {
    if (!(this.modalSourceButton instanceof HTMLButtonElement) || this.modalSourceButton.disabled) return;

    const action = this.modalSourceButton.dataset.charmBundleAction;

    if (action === 'select-base') {
      if (this.selectBase(this.modalSourceButton) && !this.giftBoxOpenTimer && !this.isGiftBoxOpen()) {
        this.closeProductModal();
      }
      return;
    }

    if (action === 'toggle-charm') {
      if (this.toggleCharm(this.modalSourceButton)) {
        if (!this.giftBoxOpenTimer && !this.isGiftBoxOpen()) {
          this.closeProductModal();
        }
      }
    }
  }

  renderModalState() {
    if (!this.modal || !(this.modalSourceButton instanceof HTMLButtonElement)) return;

    const variantId = this.modalSourceButton.dataset.variantId;
    const action = this.modalSourceButton.dataset.charmBundleAction;
    const isSelected =
      action === 'select-base'
        ? Boolean(variantId && this.base?.variantId === variantId)
        : Boolean(variantId && this.charms.has(variantId));
    const label = isSelected
      ? action === 'select-base'
        ? this.root.dataset.modalSelectedLabel || 'SELECTED'
        : this.root.dataset.modalAddedLabel || 'ADDED TO BOX'
      : this.root.dataset.modalAddLabel || 'ADD TO BOX';

    this.modal.querySelectorAll('[data-charm-bundle-modal-select]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.disabled = this.modalSourceButton.disabled;
      button.classList.toggle('is-selected', isSelected);
    });

    this.modal.querySelectorAll('[data-charm-bundle-modal-select-text]').forEach((text) => {
      text.textContent = label;
    });
  }

  escapeHTML(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

const initCharmBundleBuilders = () => {
  const builders = document.querySelectorAll('#aex-collection-list.charm-bundle-builder');

  for (const builder of builders) {
    if (!(builder instanceof HTMLElement) || builder.dataset.assetControllerReady === 'true') continue;

    builder.dataset.assetControllerReady = 'true';
    new CharmBundleAssetController(builder);
  }
};

const initCharmBundleScrollLinks = () => {
  if (document.documentElement.dataset.charmBundleScrollLinksReady === 'true') return;

  document.documentElement.dataset.charmBundleScrollLinksReady = 'true';
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-charm-bundle-scroll]') : null;
    if (!(trigger instanceof HTMLAnchorElement)) return;

    const builder = document.querySelector('[data-charm-bundle-builder-root]');
    if (!(builder instanceof HTMLElement)) return;

    event.preventDefault();
    builder.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.history && typeof window.history.replaceState === 'function') {
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }
  });
};

const initCharmBundlePage = () => {
  initCharmBundleScrollLinks();
  initCharmBundleBuilders();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCharmBundlePage, { once: true });
} else {
  initCharmBundlePage();
}